import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const base = "new-futures/";
const equityBase = "new-equity/";
const revamp = config.revamp;
const futuresConfigURL = {
    futuresSpot: config.jmw + revamp + config.jmw_content + base + "spot-comparison",
    openInterest: config.jmw + revamp + config.jmw_content + base + "oi-analysis",
    // topGainerLoser:
    //   "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-futures/topgainers-losers",
    topGainerLoser: config.jmw + revamp + config.jmw_content + base + "top-gainers-losers",
    // highestOIGainersLosers:
    //   "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-futures/highestoigainerslosers?typ=gain&ped=1D",
    highestOIGainersLosers: config.jmw + revamp + config.jmw_content + base + "oi-gainers-losers",
    // highestLowestOIRollovers:
    //   "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-futures/highlowrollovers?ped=1D&typ=high",
    highestLowestRollovers: config.jmw + revamp + config.jmw_content + base + "high-low-rollover",
    fnoBan: config.jmw + revamp + config.jmw_content + equityBase + "fnobanlist",
    highestPremiumDiscount: config.jmw +
        revamp +
        config.jmw_content +
        base +
        "highest-premium-discount",
    marketTodat: config.jmw + revamp + config.jmw_content + base + "markets-today",
    // mostActiveByVolume:
    //   "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-futures/most-active-volume?ped=1D",
    mostActiveByValue: config.jmw + revamp + config.jmw_content + base + "most-active-value",
    mostActiveByVolumn: config.jmw + revamp + config.jmw_content + base + "most-active-volume",
    // mostActiveByValue:
    //   "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/dev/revamp/new-futures/most-active-value?ped=1D",
};
export default futuresConfigURL;
